import React from "react";
import { Row, Col } from "react-bootstrap";

import NCP1 from "../Assessts/Images/NCPWorks/NCP1.png";
import NCP2 from "../Assessts/Images/NCPWorks/NCP2.png";
import NCP3 from "../Assessts/Images/NCPWorks/NCP3.png";
const ncpwork = () => {
    const NCPContent = [{
        Name: "Curriculum-Aligned Assessments", icon: NCP1,
        COntent: <div>
            <p>Assessments designed to measure core competencies and conceptual understanding.</p>
        </div>,
    },
    {
        Name: "Competency-Focused Evaluation", icon: NCP2,
        COntent: <div>
            <p>Evaluate students based on mastery, application of knowledge, and real learning outcomes beyond marks.</p>
        </div>,
    }, {
        Name: "Learning Insights &Feedback", icon: NCP3,
        COntent: <div>
            <p>Provide clear insights to identify strengths, learning gaps, and areas forcontinuous improvement.</p>
        </div>,
    },
    ]
    return (
        <>
            <div className="mt-3 Web-MainHeading mb-3">How NCP Works?</div>
            <div className="container-fluid NCP-Works ">
                <Row>
                    {NCPContent.map((NCP) => (
                        <Col>
                            <div className="dflex flexd-column alignitems gap-2 ">
                                <img src={NCP.icon} alt="ICon" />
                                <span className="Web-SubHeading">{NCP.Name}</span>
                                {NCP.COntent}
                            </div>
                        </Col>
                    ))}
                </Row>
            </div></>)
}
export default ncpwork;